import { render } from "./AddResource.vue?vue&type=template&id=01bcba0f&scoped=true"
import script from "./AddResource.vue?vue&type=script&lang=js"
export * from "./AddResource.vue?vue&type=script&lang=js"

import "./AddResource.vue?vue&type=style&index=0&id=01bcba0f&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01bcba0f"]])

export default __exports__